import { render, staticRenderFns } from "./OrganisationSort.vue?vue&type=template&id=47fc24a3&"
import script from "./OrganisationSort.vue?vue&type=script&lang=ts&"
export * from "./OrganisationSort.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports